import PropTypes from 'prop-types';
import React from 'react';
import { prefix, splitBsProps, bsClass } from './utils/bootstrapUtils';
import Collapse from '../Collapse/Collapse.js';
import { PanelContext } from '../Panel/PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
class PanelCollapse extends React.Component {
  render() {
    const {
      children
    } = this.props;
    const {
      headingId,
      bodyId,
      bsClass: _bsClass,
      expanded
    } = this.context || {};
    const [bsProps, props] = splitBsProps(this.props);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }
    return /*#__PURE__*/_jsx(Collapse, {
      in: expanded,
      ...props,
      children: /*#__PURE__*/_jsx("div", {
        className: prefix(bsProps, 'collapse'),
        children: children
      })
    });
  }
}
PanelCollapse.contextType = PanelContext;
export default bsClass('panel', PanelCollapse);